import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, API } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { devLog, devError, devWarn } from '../utils/logger';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { updateUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];

        if (!sessionId) {
          toast.error('Authentication failed');
          navigate('/auth');
          return;
        }

        // Exchange session_id for session token
        const response = await axios.get(`${API}/auth/session`, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true
        });

        // Update user in context
        updateUser(response.data);
        
        toast.success('Welcome!');
        
        // Navigate based on user type
        const redirectPath = response.data.user_type === 'supplier' ? '/dashboard' : '/marketplace';
        navigate(redirectPath, { replace: true });
      } catch (error) {
        devError('Auth callback error:', error);
        toast.error('Authentication failed');
        navigate('/auth');
      }
    };

    processCallback();
  }, [navigate, updateUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-accent mx-auto mb-4" />
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
}
